module.exports = __webpack_public_path__ + "/ff316548c03be74b60dff2563a79f13c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/clouds_googledrive.svg
 ** module id = 1651
 ** module chunks = 0
 **/